import React from "react";
import { ProgressBar } from "react-bootstrap";
import "./StepIndicator.css";

const StepIndicator = ({ currentStep, totalSteps }) => {
  const step = Math.min(Math.max(currentStep, 1), totalSteps);
  const percentage = ((step - 1) / (totalSteps - 1)) * 100;

  return (
    <div className="position-relative my-4 mx-4">
      {/* Progress bar */}
      <ProgressBar
        now={percentage}
        variant="primary"
        style={{ height: "8px", borderRadius: "10px" }}
      />

      {/* Step circles */}
      <div className="step-circles">
        {[...Array(totalSteps)].map((_, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < step;
          const isCurrent = stepNumber === step;

          return (
            <div
              key={index}
              className={`step-circle ${
                isCompleted ? "completed" : isCurrent ? "current" : ""
              }`}
              style={{
                left: `${(index / (totalSteps - 1)) * 100}%`,
              }}
            >
              {stepNumber}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StepIndicator;
